import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuthentication } from "../../../Hooks/useAuthentication";
import "./home.css";

const Home = () => {
  const navigate = useNavigate();
  const { username, isAuthenticated, role } = useAuthentication();

  const name = username || "Operador";

  // ✅ roles permitidos para ver formularios
  const normalizedRole = (role || "").toString().trim().toLowerCase();
  const canViewForms = ["administrador", "administrador-t1", "administrador-t2", "supervisor"].includes(
    normalizedRole
  );

  const onlyAdmin = normalizedRole === "administrador";

  return (
    <div className="home-page">
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-8">
            <div className="card home-card border-0">
              <div className="card-body p-4 p-md-5">
                {/* Header */}
                <div className="home-header">
                  <div>
                    <h1 className="home-title">
                      {isAuthenticated ? `Hola, ${name} 👋` : "Bienvenido 👋"}
                    </h1>
                    <p className="home-subtitle">
                      {isAuthenticated
                        ? `Sesión activa${role ? ` (${role})` : ""}.`
                        : "Inicia sesión para continuar."}
                    </p>
                  </div>

                  <span className="home-badge">Quality Seal</span>
                </div>

                <hr className="my-4" />

                {!isAuthenticated ? (
                  <div className="alert alert-warning mb-0 home-alert">
                    No has iniciado sesión.
                  </div>
                ) : (
                  <div className="home-actions">
                    <div className="home-actions-row">
                      <div className="home-icon">📝</div>

                      <div className="flex-grow-1">
                        <div className="home-actions-title">Acciones</div>
                        <div className="home-actions-desc">
                          Crea o consulta formularios según tu rol.
                        </div>

                        <div className="home-buttons">
                          <button
                            className="btn home-btn home-btn-primary"
                            onClick={() => navigate("/create-form")}
                          >
                            Crear formulario
                          </button>

                          {canViewForms && (
                            <button
                              className="btn home-btn home-btn-outline"
                              onClick={() => navigate("/forms")}
                            >
                              Ver formularios
                            </button>
                          )}

                          {onlyAdmin && (
                            <button
                              className="btn home-btn home-btn-outline"
                              onClick={() => navigate("/create-user")}
                            >
                              Crear Usuario
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="home-footer">
                  © {new Date().getFullYear()} Quality Seal
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;